exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.fade-enter-active,\n.fade-leave-active {\n  -webkit-transition-duration: 0ms;\n          transition-duration: 0ms;\n}\n.fade-enter,\n.fade-leave-to {\n  opacity: 1;\n}\n", "", {"version":3,"sources":["/usr/src/app/node_modules/@intelipost-modules/secure-psl/features/list/components/ScWarehouseTaginput.vue"],"names":[],"mappings":";AACA;;EAEE,iCAAiC;UACzB,yBAAyB;CAClC;AACD;;EAEE,WAAW;CACZ","file":"ScWarehouseTaginput.vue","sourcesContent":["\n.fade-enter-active,\n.fade-leave-active {\n  -webkit-transition-duration: 0ms;\n          transition-duration: 0ms;\n}\n.fade-enter,\n.fade-leave-to {\n  opacity: 1;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-10a8ce0c","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/@intelipost-modules/secure-psl/features/list/components/ScWarehouseTaginput.vue
// module id = izWm
// module chunks = 72